<template>
  <SearchContainer @search="search">
    <template slot="default">
      <div class="row">
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="text"
            :label="$t('sections.locationTariffs.search.locationId')"
            :field="query.locationId"
            @input="(e) => onInput('locationId', e)"
          />
        </div>
        <div class="col-12 col-sm-4 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.locationTariffs.search.type')"
            :items="$t('sections.locationTariffs.search.typeOptions')"
            :field="query.type"
            @input="(e) => onInput('type', e)"
            button
            @onClick="search"
          />
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'LocationTariffsListSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        locationId: '',
        type: '',
      },
    };
  },
  computed: {
    validSearch() {
      // TODO check required fields
      return true;
    },
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        locationId: '',
        type: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped></style>
